import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../../Components/Navbar/navbar";
import styles from "../../../Styles/edit.module.css";
import { HiEye, HiEyeOff, HiSearch, HiX } from "react-icons/hi";
import { useLocation, useNavigate, useParams } from "react-router";
import axios from "axios";
import { getUser, Url } from "../../../../Constants/globals";
import RefreshToken from "../../../../Components/RefreshToken/RefreshToken";
import Dropdown from "../../../../Components/Dropdown/dropdown";
import GoBack from "../../../../Components/GoBack/goback";
import stylesModal from "../../../../Components/DeleteModal/deletemodal.module.css";
import Loading from "../../../../Components/Loading/loading";
import Alert from "../../../../Components/Alert/alert";
import QRDownload from "../../../../Components/QRCode/QRCode";

async function deleteNewInfo(id) {
    try {
        await axios.delete(`${Url}/personal-links/${id}`, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [200, <Alert type={"success"}>Informação eliminada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await deleteNewInfo(id);
            else window.location.reload();
        }
        else {
            console.error(err);
            return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar a informação"}</Alert>];
        }
    };
}

async function addNewInfo(cardId, type, value, customHandle) {
    if (!customHandle) return ["", <Alert type={"error"}>{`Indique o nome do campo`}</Alert>];
    if (!value) return ["", <Alert type={"error"}>{`Indique o valor do campo ${customHandle}`}</Alert>];

    try {
        const response = await axios.post(`${Url}/business-cards/${cardId}/links`,
            {
                platform: type.handle,
                label: customHandle,
                url: value
            }, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [response.data, <Alert type={"success"}>Informação adicionada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await addNewInfo(cardId, type, value, customHandle);
            else window.location.reload();
        }
        else {
            console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a informação");
            return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a informação"}</Alert>];
        }
    };
}

async function addCard(user, name, company, cargo, departamento, contact) {
    if (!name || !user || !company) return ["", <Alert type={"error"}>Os campos colaborador, nome e empresa são obrigatórios</Alert>];
    try {
        const response = await axios.post(`${Url}/business-cards`,
            {
                card_holder: name,
                job_title: cargo,
                department: departamento,
                user_id: user.id,
                company_id: company.id,
                contact: contact ? contact : null
            }, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [response.data, <Alert type={"success"}>Cartão adicionado com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await addCard(user, name, company, cargo, departamento, contact);
            else window.location.reload();
        }
        else {
            console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o cartão");
            return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o cartão"}</Alert>];
        }
    };
}

async function editCard(cardId, name, cargo, departamento, contact, companyLinks) {
    if (!name) return ["", <Alert type={"error"}>Os campos nome, colaborador e empresa são obrigatórios</Alert>];
    try {
        const response = await axios.patch(`${Url}/business-cards/${cardId}`,
            {
                card_holder: name,
                job_title: cargo,
                department: departamento,
                contact: contact ? contact : null,
                visible_company_link_ids: companyLinks?.length ? companyLinks.filter(c => !c.dont_show).map(c => c.id) : []
            }, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [response.data, <Alert type={"success"}>Cartão editado com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await editCard(cardId, name, cargo, departamento, contact, companyLinks);
            else window.location.reload();
        }
        else {
            console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o cartão");
            return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o cartão"}</Alert>];
        }
    };
}

function ModalAddCard({ closeModal, setSelected, setContacto, setName }) {

    const [searchName, setSearchName] = useState("");
    const [isPoppedOut, setIsPoppedOut] = useState(false);
    const [employees, setEmployees] = useState([]);

    async function chooseUser(u) {
        setSelected(u);
        if (u.phone) setContacto(`+351${u.phone}`);
        if (u.first_name && u.last_name) setName(`${u.first_name} ${u.last_name}`);
        handleClose();
    }

    async function fetchEmployees(page, nome) {
        try {
            const res = await axios.get(`${Url}/employees?per_page=12&page=${page ? page : 1}${nome ? `&nome=${nome}` : ""}`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                }
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchEmployees(page, nome);
                else window.location.reload();
            }
            else {
                console.error(err);
                return "";
            }
        };
    }

    async function getEmployees() {
        const empData = await fetchEmployees(1, searchName);
        if (empData) {
            setEmployees(empData.users ? empData.users : []);
        }
    }

    function handleClose() {
        setIsPoppedOut(true);
        setTimeout(() => {
            closeModal("");
        }, 250);
    }

    return (
        <div className={`${stylesModal.bodyDelete} ${isPoppedOut ? stylesModal.popout : stylesModal.popin}`}>
            <div className={stylesModal.center}>
                <div className={stylesModal.column}>
                    <h2 style={{ marginTop: 0 }}>
                        Selecionar colaborador
                    </h2>
                    <div className={styles.formBlockSection}>
                        <input
                            type="text"
                            placeholder="Procurar colaborador"
                            value={searchName}
                            onChange={(e) => setSearchName(e.target.value)}
                            onKeyDown={(e) => { if (e.key === "Enter") { getEmployees() } }}
                        />
                        <button
                            style={{ marginLeft: "0" }}
                            className={styles.btnSearch}
                            onClick={() => getEmployees()}
                        >
                            <HiSearch size={18} />
                        </button>
                    </div>
                    <div style={{ marginTop: "20px" }} className={styles.chooseCardUsers}>
                        {
                            employees?.length ?
                                employees.map((u, index) =>
                                    <div key={index} className={styles.chooseCardUser} onClick={() => chooseUser(u)}>
                                        {u.full_name} (<i>{u.num}</i>)
                                    </div>
                                )
                                : ""
                        }
                    </div>
                    <div className={stylesModal.buttons}>
                        <button className={stylesModal.backButton} onClick={() => handleClose()}>Regressar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function EditarCartoes({ userPermissions }) {

    const location = useLocation();
    const { state } = location;
    const navigate = useNavigate();
    const { slug } = useParams();
    const newInfoRef = useRef();

    const [id, setId] = useState("");
    const [modalAddCard, setModalAddCard] = useState("");
    const [alert, setAlert] = useState("");
    const [loading, setLoading] = useState("");
    const [loadingData, setLoadingData] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState("");

    const [selectedColaborador, setSelectedColaborador] = useState("");
    const [userName, setUserName] = useState("");

    const [cargo, setCargo] = useState("");
    const [departamento, setDepartamento] = useState("");
    const [contacto, setContacto] = useState("");

    const [emailWallet, setEmailWallet] = useState("");

    const [newIndexValue, setNewIndexValue] = useState("");

    const [newInfo, setNewInfo] = useState("");
    const [newInfoHandle, setNewInfoHandle] = useState("");
    const infoTypes = [
        {
            id: 1,
            name: "Email",
            handle: "email"
        },
        {
            id: 2,
            name: "WhatsApp",
            handle: "whatsapp",
            default: "+351"
        },
        {
            id: 3,
            name: "Instagram",
            handle: "instagram",
            default: "www.instagram.com/"
        },
        {
            id: 4,
            name: "Facebook",
            handle: "facebook",
            default: "www.facebook.com/"
        },
        {
            id: 5,
            name: "LinkedIn",
            handle: "linkedin",
            default: "www.linkedin.com/in/"
        },
        {
            id: 6,
            name: "Website",
            handle: "website",
            default: "www."
        },
        {
            id: 7,
            name: "Contacto",
            handle: "mobile",
            default: "+351"
        },
        {
            id: 8,
            name: "Morada",
            handle: "address"
        },
        {
            id: 9,
            name: "TikTok",
            handle: "tiktok",
            default: "www.tiktok.com/"
        },
        {
            id: 10,
            name: "YouTube",
            handle: "youtube",
            default: "www.youtube.com/"
        }
    ];
    const [selectedInfoType, setSelectedInfoType] = useState("");

    const [info, setInfo] = useState([]);

    async function fetchCompanies() {
        try {
            const res = await axios.get(`${Url}/business-companies/`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchCompanies();
                else window.location.reload();
            }
            else {
                console.error(err);
                return [];
            }
        };
    }

    async function fetchDetails() {
        try {
            const res = await axios.get(`${Url}/business-cards/public/${slug}`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchDetails();
                else window.location.reload();
            }
            else {
                console.error(err);
                return "";
            }
        };
    }

    async function assignData() {
        const companiesData = await fetchCompanies();
        setCompanies(companiesData);
        if (slug) {
            const detailsData = await fetchDetails();
            if (detailsData) {
                await getInfo(detailsData.id);
                setId(detailsData.id);
                setContacto(detailsData.contact);
                setCargo(detailsData.job_title);
                setDepartamento(detailsData.department);
                setSelectedCompany(
                    detailsData.visible_company_link_ids?.length ?
                        {
                            ...detailsData.company,
                            company_links: detailsData.company.company_links.map(a =>
                                detailsData.visible_company_link_ids.includes(a.id)
                                    ? { ...a, dont_show: false }
                                    : { ...a, dont_show: true }
                            )
                        }
                        : detailsData.company
                );
                setSelectedColaborador(detailsData.user);
                setUserName(detailsData.card_holder ? detailsData.card_holder : "");
            }
            else navigate("/cartoes");
        }
        setLoadingData(false);
    }

    useEffect(() => {
        assignData();
    }, []);

    async function fetchInfo(thisId) {
        try {
            const res = await axios.get(`${Url}/business-cards/${thisId ? thisId : id}/links`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchInfo(thisId);
                else window.location.reload();
            }
            else {
                console.error(err);
                return [];
            }
        };
    }

    async function getInfo(thisId) {
        const infoData = await fetchInfo(thisId);
        setInfo(infoData);
    }

    async function getAlertAddInfo() {
        await setAlert("");
        const res = await addNewInfo(id, selectedInfoType, newInfo, newInfoHandle);
        setAlert(res[1]);
        getInfo();
    }

    async function getAlertDelete(infoId) {
        await setAlert("");
        const res = await deleteNewInfo(infoId);
        setAlert(res[1]);
        getInfo();
    }

    async function getAlertAdd() {
        await setLoading(<Loading />);
        await setAlert("");
        const res = await addCard(selectedColaborador, userName, selectedCompany, cargo, departamento, contacto);
        setLoading("");
        if (res[0]) {
            setId(res[0].id)
            navigate(`/cartoes/${res[0].slug}`);
        }
        else setAlert(res[1]);
    }

    async function getAlertEdit() {
        await setLoading(<Loading />);
        await setAlert("");
        const res = await editCard(id, userName, cargo, departamento, contacto, selectedCompany.company_links);
        setLoading("");
        setAlert(res[1]);
    }

    useEffect(() => {
        setNewInfoHandle(selectedInfoType.name ? selectedInfoType.name : "");
        setNewInfo(selectedInfoType.default ? selectedInfoType.default : "");
        if (newInfoRef?.current) newInfoRef.current.focus();
    }, [selectedInfoType]);

    function handleDeleteCompanyLink(link_id) {
        setSelectedCompany(prev => ({
            ...prev,
            company_links: prev.company_links.map(a =>
                a.id === link_id ? { ...a, dont_show: a.dont_show ? false : true } : a
            )
        }));
    }

    async function changeFieldPosition(link_id) {
        if (newIndexValue) {
            try {
                await axios.patch(`${Url}/personal-links/${link_id}/position`,
                    {
                        new_position: newIndexValue
                    }, {
                    headers: {
                        Authorization: "Bearer " + getUser().token,
                    },
                });
                setNewIndexValue("");
                return getInfo();
            }
            catch (err) {
                if (err.request && err.request.status === 401) {
                    var newToken = await RefreshToken(err);
                    if (newToken) return await changeFieldPosition(link_id);
                    else window.location.reload();
                }
                else {
                    console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar a ordenação dos campos");
                    return;
                }
            };
        }
    }

    async function sendWalletCard() {
        await setAlert("");
        if (!emailWallet.trim()) return setAlert(<Alert type={"error"}>Indique o email a receber o cartão</Alert>);
        try {
            await axios.post(`${Url}/business-cards/${id}/send-pkpass`,
                {
                    email: emailWallet
                }, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return setAlert(<Alert type={"success"}>Cartão enviado com sucesso</Alert>);
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await sendWalletCard();
                else window.location.reload();
            }
            else {
                console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao enviar o cartão da wallet");
                return setAlert(<Alert type={"error"}>Ocorreu um erro ao enviar o cartão da wallet</Alert>);
            }
        };
    }

    return (
        <div className="body">
            {alert}
            {loading}
            {modalAddCard}
            <NavBar current={"colaboradores"} setDisappear={setLoadingData} userPermissions={userPermissions} />
            {
                loadingData ? ""
                    :
                    <div className={styles.content}>
                        <GoBack backRoute={`/cartoes`} backState={state?.page ? { page: state.page, nomeSearch: state.nomeSearch ?? "" } : {}} />
                        <h1 className={styles.backgroundName}>
                            {
                                slug ? "Editar cartão" : "Adicionar cartão"
                            }
                        </h1>
                        <div className={styles.formBlock}>
                            <div style={slug ? { opacity: 0.6, cursor: "not-allowed" } : {}} className={styles.formBlockSectionButton} onClick={() => !slug && setModalAddCard(<ModalAddCard closeModal={setModalAddCard} setAlert={setAlert} setLoading={setLoading} setSelected={setSelectedColaborador} setContacto={setContacto} setName={setUserName} />)}>
                                <p style={{ margin: 0, padding: "1rem" }}>
                                    {
                                        selectedColaborador ?
                                            selectedColaborador.full_name
                                            :
                                            "Selecionar colaborador"
                                    }
                                </p>
                            </div>
                            <div className={styles.formBlockSection}>
                                <p>
                                    Nome:
                                </p>
                                <input
                                    type="text"
                                    onChange={(e) => setUserName(e.target.value)}
                                    value={userName}
                                />
                            </div>
                            <div className={styles.formBlockSection}>
                                <p>
                                    Contacto:
                                </p>
                                <input
                                    type="text"
                                    onChange={(e) => setContacto(e.target.value)}
                                    value={contacto}
                                />
                            </div>
                            <Dropdown
                                disabled={slug}
                                label={"Empresa:"}
                                placeholder={"Escolher empresa"}
                                items={companies}
                                value={selectedCompany}
                                onValueChange={setSelectedCompany}
                            />
                            <div className={styles.formBlockSection}>
                                <p>
                                    Cargo:
                                </p>
                                <input
                                    type="text"
                                    onChange={(e) => setCargo(e.target.value)}
                                    value={cargo}
                                />
                            </div>
                            <div className={styles.formBlockSection}>
                                <p>
                                    Departamento:
                                </p>
                                <input
                                    type="text"
                                    onChange={(e) => setDepartamento(e.target.value)}
                                    value={departamento}
                                />
                            </div>
                            <div style={{ width: "100%" }}>
                                <div className={styles.formBlockSection}>
                                    <p>
                                        Link QR Code:
                                    </p>
                                    <input
                                        disabled
                                        value={`${Url}/business-cards/public/${slug}/vcard/download`}
                                    />
                                    <button
                                        style={{ marginRight: "10px" }}
                                        className={styles.textButton}
                                        onClick={async () => {
                                            await setAlert("");
                                            navigator.clipboard.writeText(`${Url}/business-cards/public/${slug}/vcard/download`);
                                            setAlert(<Alert type="success">Link copiado</Alert>)
                                        }}
                                    >
                                        Copiar
                                    </button>
                                </div>
                                <QRDownload
                                    filename={slug}
                                    className={styles.btn}
                                    value={`${Url}/business-cards/public/${slug}/vcard/download`}
                                />
                            </div>
                            <div style={{ width: "100%" }}>
                                <div className={styles.formBlockSection}>
                                    <p>
                                        Email:
                                    </p>
                                    <input
                                        placeholder="Insira o email a receber o cartão da wallet"
                                        value={emailWallet}
                                        onChange={(e) => setEmailWallet(e.target.value)}
                                    />
                                </div>
                                <button style={{ marginTop: 0 }} className={styles.btn} onClick={() => sendWalletCard()}>
                                    Enviar cartão da wallet
                                </button>
                            </div>
                        </div>
                        {
                            slug ?
                                <>
                                    <h3 style={{ textAlign: "center" }}>Informações da empresa</h3>
                                    {
                                        selectedCompany?.company_links?.length ?
                                            <div style={{ marginBottom: "1rem" }} className={styles.formBlock}>
                                                {
                                                    selectedCompany.company_links.map((i, index) =>
                                                        <div key={index} className={styles.formBlockSection}>
                                                            <p>
                                                                {i.label ? i.label : i.platform === "mobile" ? "Contacto" : i.platform}:
                                                            </p>
                                                            <input disabled type="text" value={i.url} />
                                                            {
                                                                i.dont_show ?
                                                                    <HiEye title="Mostrar link" style={{ marginRight: "8px", cursor: "pointer" }} onClick={() => handleDeleteCompanyLink(i.id)} />
                                                                    :
                                                                    <HiEyeOff title="Esconder link" style={{ marginRight: "8px", cursor: "pointer" }} color="red" onClick={() => handleDeleteCompanyLink(i.id)} />
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            : ""
                                    }
                                    <h3 style={{ textAlign: "center" }}>Outras informações</h3>
                                    {
                                        info?.length ?
                                            <div style={{ marginBottom: "1rem" }} className={styles.formBlock}>
                                                {
                                                    info.map((i, index) =>
                                                        <div key={index} className={styles.formBlockSection}>
                                                            <input
                                                                type="number"
                                                                placeholder={`${index}`}
                                                                style={{ width: "40px", paddingRight: 0, backgroundColor: "var(--background)" }}
                                                                min={0}
                                                                max={info.length - 1}
                                                                onChange={(e) => setNewIndexValue(e.target.value)}
                                                                onKeyDown={(e) => e.key === "Enter" && changeFieldPosition(i.id)}
                                                            />
                                                            <p>
                                                                {i.label ? i.label : i.platform === "mobile" ? "Contacto" : i.platform}:
                                                            </p>
                                                            <input disabled type="text" value={i.url} />
                                                            <HiX size={14} style={{ minWidth: "14px", marginRight: "8px", cursor: "pointer" }} color="red" onClick={() => getAlertDelete(i.id)} />
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            : ""
                                    }
                                    <h3 style={{ textAlign: "center" }}>Adicionar</h3>
                                    <div className={styles.formBlock}>
                                        <Dropdown
                                            label={"Tipo:"}
                                            placeholder={"Escolher tipo de informação"}
                                            items={infoTypes}
                                            value={selectedInfoType}
                                            onValueChange={setSelectedInfoType}
                                        />
                                        {
                                            selectedInfoType ?
                                                <div className={styles.formBlockSection}>
                                                    <input
                                                        style={{ backgroundColor: "var(--background)", width: "200px" }}
                                                        type="text"
                                                        placeholder="Nome do campo"
                                                        value={newInfoHandle}
                                                        onChange={(e) => setNewInfoHandle(e.target.value)}
                                                    />
                                                    <input
                                                        ref={newInfoRef}
                                                        type="text"
                                                        placeholder="Valor"
                                                        value={newInfo}
                                                        onChange={(e) => setNewInfo(e.target.value)}
                                                    />
                                                    <button
                                                        className={styles.btnFileType}
                                                        style={{ width: "160px", marginRight: "8px", backgroundColor: "var(--hoverItem)" }}
                                                        onClick={() => getAlertAddInfo()}
                                                    >
                                                        Adicionar
                                                    </button>
                                                </div>
                                                :
                                                <div></div>
                                        }
                                    </div>
                                </>
                                : ""
                        }
                        {
                            slug ?
                                <div>
                                    <button className={styles.btn} onClick={() => getAlertEdit()}>
                                        Guardar alterações
                                    </button>
                                </div>
                                :
                                <button className={styles.btn} onClick={() => getAlertAdd()}>
                                    Adicionar cartão
                                </button>
                        }
                    </div>
            }
        </div>
    );
}

export default EditarCartoes;